// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"_24yRuDONDbhdeXz_UzQclj","inputWrapper":"_24yRuDONDbhdeXz_UzQclj","icon":"_1Q8mywOKSWgP3SVI8nSL75"};